import { FC, PropsWithChildren } from 'react'
import { MemoryRouter } from 'react-router-dom'

import { App } from 'antd'

import Auth from './Auth'
import { Config } from './Config'
import { Data } from './Data'
import { Intl } from './Intl'
import { Routing } from './Routing'
import Seo from './Seo'

const Root = () => {
  return (
    <Auth>
      <Data apiUrl={import.meta.env.VITE_API_BASE_URL ?? ''}>
        <Intl>
          <Config>
            <Seo>
              <App>
                <Routing />
              </App>
            </Seo>
          </Config>
        </Intl>
      </Data>
    </Auth>
  )
}

const Storybook: FC<PropsWithChildren<{ theme?: 'dark' | 'light'; apiUrl?: string }>> = ({
  theme,
  apiUrl,
  children,
}) => {
  return (
    <Data apiUrl={apiUrl}>
      <Intl>
        <Config defaultTheme={theme}>
          <App>
            <MemoryRouter>{children}</MemoryRouter>
          </App>
        </Config>
      </Intl>
    </Data>
  )
}

export { Storybook }

export default Root
